@if (propertyViewModel?.securityAccess == null) {
  @if (!multiline && !useChips) {
    <nts-base-text-box
      #baseTextBox
      (onBlur)="onBlur($event)"
      (inputChange)="onInput($event)"
      (onKeyDown)="onKeyDown($event)"
      [maskSettings]="this.maskSettings"
      (maskObject)="this.mask = $event"
      [customCommandList]="customCommandList"
      (onValueChange)="modelChange($event)"
      (onFinishEditing)="onFinishEditing.emit($event)"
      [listenClickOutside]="listenClickOutside"
      [maxLength]="propertyViewModel.maxLength$ | async"
      [tabIndex]="tabIndex"
      [showErrorTooltip]="showErrorTooltip"
      [showErrorBorder]="showErrorBorder"
      [errorList]="$safeNavigationMigration(propertyViewModel?.errors$) | async"
      [isDisabled]="isDisabled || (!softDisable && !(propertyViewModel.isEnabled$ | async))"
      [defaultBorderColor]="propertyViewModel.defaultColor"
      [activeBorderColor]="propertyViewModel.activeColor"
      [hoverBorderColor]="propertyViewModel.hoverColor"
      [value]="initialValue != null ? initialValue : propertyViewModel.formattedValue$ | async"
      (viewReady)="onBaseViewReady()"
      [isReadonly]="isDisabled || (softDisable && !(propertyViewModel.isEnabled$ | async))"
      [placeholder]="placeholder"
      [class.is-multi-language]="isMultiLanguage"
      [attr.data-property-name]="propertyViewModel.propertyName">
    </nts-base-text-box>
  }
  @if (multiline && !useChips) {
    <nts-base-text-area-box
      #baseTextBoxArea
      (inputChange)="onInput($event)"
      (onBlur)="onBlur($event)"
      (onValueChange)="modelChange($event)"
      [maxLength]="propertyViewModel.maxLength$ | async"
      [tabIndex]="tabIndex"
      [showErrorTooltip]="showErrorTooltip"
      [showErrorBorder]="showErrorBorder"
      [errorList]="$safeNavigationMigration(propertyViewModel?.errors$) | async"
      [isDisabled]="isDisabled || (!softDisable && !(propertyViewModel.isEnabled$ | async))"
      [defaultBorderColor]="propertyViewModel.defaultColor"
      [activeBorderColor]="propertyViewModel.activeColor"
      [hoverBorderColor]="propertyViewModel.hoverColor"
      [value]="initialValue != null ? initialValue : propertyViewModel.formattedValue$ | async"
      (viewReady)="onBaseViewReady()"
      [isReadonly]="isDisabled || (softDisable && !(propertyViewModel.isEnabled$ | async))"
      [placeholder]="placeholder"
      [class.is-multi-language]="isMultiLanguage"
      [attr.data-property-name]="propertyViewModel.propertyName">
    </nts-base-text-area-box>
  }
  @if (isMultiLanguage && !useChips) {
    <div
      [popper]="languageDescription"
      [popperDisabled]="languageDescription?.length === 0"
      [popperTrigger]="ngxPopperjsTriggers.hover"
      popperApplyClass="info"
      [popperDelay]="1000"
      [popperPlacement]="ngxPopperjsPlacements.TOP"
      [popperPreventOverflow]="false"
      [popperHideOnScroll]="true"
      popperAppendTo="body"
      class="multi-language-label">
      {{languageCode?.toUpperCase()}}
    </div>
  }
  @if (useChips && chipsOptions?.optionsList == null) {
    <nts-base-chips-box
      #baseChipsBox
      (onBlur)="onBlur($event)"
      [maskSettings]="this.maskSettings"
      [customCommandList]="customCommandList"
      (onValueChange)="modelChange($event)"
      (onFinishEditing)="onFinishEditing.emit($event)"
      [listenClickOutside]="listenClickOutside"
      [tabIndex]="tabIndex"
      [multiline]="multiline"
      [showErrorTooltip]="showErrorTooltip"
      [showErrorBorder]="showErrorBorder"
      [errorList]="$safeNavigationMigration(propertyViewModel?.errors$) | async"
      [isDisabled]="isDisabled || (!softDisable && !(propertyViewModel.isEnabled$ | async))"
      [defaultBorderColor]="propertyViewModel.defaultColor"
      [activeBorderColor]="propertyViewModel.activeColor"
      [hoverBorderColor]="propertyViewModel.hoverColor"
      [value]="valueForChips"
      (viewReady)="onBaseViewReady()"
      [isReadonly]="isDisabled || (softDisable && !(propertyViewModel.isEnabled$ | async))"
      [placeholder]="placeholder"
      [attr.data-property-name]="propertyViewModel.propertyName">
    </nts-base-chips-box>
  }
  @if (useChips && chipsOptions?.optionsList != null) {
    <nts-base-select-chips-box
      #baseSelectChipsBox
      (onBlur)="onBlur($event)"
      [customCommandList]="customCommandList"
      [options$]="optionsListFromChipsOptions$"
      [optionLabel]="chipsOptions?.optionDescriptionField ?? chipsOptions?.optionCodeField"
      [optionValue]="$safeNavigationMigration(chipsOptions?.optionCodeField)"
      (onValueChange)="modelChange($event)"
      [appendTo]="appendTo"
      (onFinishEditing)="onFinishEditing.emit($event)"
      [listenClickOutside]="listenClickOutside"
      [tabIndex]="tabIndex"
      [multiline]="multiline"
      [showErrorTooltip]="showErrorTooltip"
      [showErrorBorder]="showErrorBorder"
      [errorList]="$safeNavigationMigration(propertyViewModel?.errors$) | async"
      [isDisabled]="isDisabled || (!softDisable && !propertyViewModel.isEnabled)"
      [defaultBorderColor]="propertyViewModel.defaultColor"
      [activeBorderColor]="propertyViewModel.activeColor"
      [hoverBorderColor]="propertyViewModel.hoverColor"
      [overlayOptions]="$safeNavigationMigration(chipsOptions?.overlayOptions)"
      [value]="valueForChips"
      (viewReady)="onBaseViewReady()"
      [isReadonly]="isDisabled || (softDisable && !propertyViewModel.isEnabled)"
      [placeholder]="placeholder"
      [attr.data-property-name]="propertyViewModel.propertyName">
    </nts-base-select-chips-box>
  }
} @else {
  <nts-base-security-text-box
    #baseSecurityTextBox
    (viewReady)="onBaseViewReady()"
    [accessMode]="propertyViewModel.securityAccess"
    [value]="propertyViewModel.formattedValue$ | async">
  </nts-base-security-text-box>
}


